// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .item-wrapper[data-v-29740717]{cursor:pointer}[dir] .item-wrapper[data-v-29740717]:hover{background-color:#f3f5f6}.item-wrapper .title[data-v-29740717]{font-size:.9rem}.item-wrapper .fixed-field-value[data-v-29740717]{font-size:.8rem;color:#6e8491}[dir] .item-wrapper .fixed-field-value[data-v-29740717]{margin:0}.item-wrapper .module-icon[data-v-29740717]{color:#6e8491}", ""]);
// Exports
module.exports = exports;
